<template>
  <transition name="slide-fade">
    <div class="s-anchor-nav" v-show="visible">
      <div class="s-anchor-nav-item" v-for="(item, index) in list" :key="index" @click="handleClick(item, index)">
        <img :src="item.default" alt=""  :style="{...itemStyle, margin: itemMargin,}"/>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'SVersionNav',
  props: {
    list: {
      type: Array,
      required: true
    },
    itemSize: {
      type: String,
      default: '341px 98px'
    },
    itemMargin: {
      type: String,
      default: '_ _ 5px _'
    }
  },
  data () {
    return {
      visible: false,
      active: 0,
      hoverIndex: null,
      container: null,
      targetOffsetTopList: []
    }
  },
  computed: {
    itemStyle () {
      const arr = this.itemSize.split(' ')
      return {
        width: arr[0] || '',
        height: arr[1] || '',
        margin: this.itemMargin
      }
    }
  },
  mounted () {
    this.container = document.querySelector('#pageRenderParent') || window
    this.container.addEventListener('scroll', this.onScroll)
  },
  methods: {
    setTopList (reset = false) {
      if (reset || !this.targetOffsetTopList.length) {
        if (this.list.some(item => !item.targetId)) { // 如果锚点ID未完整填入
          console.warn('[SAnchorNav]:请完善锚点ID')
          return
        }
        this.targetOffsetTopList = this.list.map(item => {
          return document.querySelector('#' + item.targetId).offsetTop
        })
      }
    },
    hide () {
      this.visible = false
    },
    show () {
      this.visible = true
    },
    handleClick (item, index) {
      this.setTopList(true)
      this.scrollTo(this.targetOffsetTopList[index])
    },
    scrollTo (top) {
      this.container.scrollTo({
        top,
        behavior: 'smooth'
      })
    },
    onScroll (e) {
      this.setTopList()
      const rangeList = []
      this.targetOffsetTopList.forEach((item, index) => {
        rangeList.push([item, this.targetOffsetTopList[index + 1] || +Infinity])
      })
      const scrollTop = this._getScrollTop(e.target)
      // console.log('scrollTop', scrollTop)
      if (scrollTop >= 200) {
        this.visible = true
      } else {
        this.visible = false
      }
      let getIt = false
      rangeList.forEach((item, index) => {
        if (getIt) return
        const tolerance = 200 // 误差（缩放情况下）
        if (item[0] <= scrollTop + tolerance && scrollTop + tolerance < item[1]) {
          this.active = index
          getIt = true
        } else {
          this.active = -1
        }
      })
    },
    _getScrollTop (e) {
      if (e.scrollTop !== undefined) {
        return e.scrollTop
      } else if (e.document) {
        return (
          e.document.documentElement.scrollTop ||
          window.pageYOffset ||
          e.document.body.scrollTop ||
          0
        )
      }
      return e.documentElement.scrollTop || e.body.scrollTop || 0
    }
  },
  beforeDestroy () {
    this.container.removeEventListener('scroll', this.onScroll)
  }
}
</script>
<style lang="scss" scoped>
.s-anchor-nav {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
  height: 100%;
  .s-anchor-nav-item {
    transition: .3s;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;

    &:hover {
      //filter: brightness(120%);
    }

    //img{
    //  transition: .3s;
    //  display: block;
    //}
  }
}
</style>
